import React, { Component } from "react";
import ListingPage from "../Controls/ListingPage";
import Window from "../Controls/Window";
import SMS from "../../Settings/SMS/SMS";

class TransactionSMSTemplateList extends Component {

  constructor(props) {

    super(props);

    this.state = {

      list: [],
      totalCount: 0,
      loading: false,
      page: 1,
      pageSize: 25,

      showDelete: false,
      showAddMessageTemplate: false,
      selectedRow: null,

      listPageSettings: {

        Title: "Transactional SMS Template",

        Search: {
          showSearch: false,
        },

        HeaderButtons: [
          {
            ButtonType: "Button",
            Type: "primary",
            Text: "New",
            Icon: "add",
            Action: "new"
          }
        ],

     Columns: [
          {
            Name: "Template Name",
            Type: "field",
            Columns: [{ Column: "Name" }],
          },
          { Name: "Module", Type: "field", Columns: [{ Column: "Module" }] },
          {
            Name: "Transaction Type",
            Type: "field",
            Columns: [{ Column: "TransactionType" }],
          },
          {
            Name: "SMS Content",
            Type: "field",
            Columns: [{ Column: "SMSTemplate" }],
          },
          {
            Name: "Name",
            Type: "field",
            ShowInMobile: true,
            Columns: [{ Column: "Name" }, { Column: "SMSTemplate" }],
          },
        ],

        RowButtons: [
          {
            ButtonType: "ImageButton",
            Type: "edit",
            Text: "Edit",
            Icon: "edit"
          },
          {
            ButtonType: "ImageButton",
            Type: "delete",
            Text: "Delete",
            Icon: "delete"
          }
        ]
      }
    };
  }

  componentDidMount() {
    this.loadData();
  }


  // =====================
  // LOAD DATA
  // =====================

  loadData = async () => {

    this.setState({ loading: true });

    try {

      let tmp = await this.props.getSMSTemplates(
        this.props.user.user.RegistrationID
      );
      let smsTemplates = [];
      for (let i = 0; i < tmp.length; i++) {
        let type = tmp[i].hasOwnProperty("SMSType")
          ? tmp[i].SMSType
          : "Transactional";
        if (type === "Transactional") {
          smsTemplates.push(tmp[i]);
        }
      }
      this.setState({
        list: smsTemplates,
        totalCount: smsTemplates.length,
        loading: false,
      });
      

    

    } catch (error) {

      console.error(error);

      this.setState({ loading: false });

      this.props.getToastr("Failed to fetch sms template");

    }
  };


  // =====================
  // PAGINATION
  // =====================

  onNextClick = () => {

    const totalPages =
      Math.ceil(this.state.totalCount / this.state.pageSize);

    if (this.state.page < totalPages) {

      this.setState({
        page: this.state.page + 1
      });

    }

  };


  onPreviousClick = () => {

    if (this.state.page > 1) {

      this.setState({
        page: this.state.page - 1
      });

    }

  };


  onFirstClick = () => {

    this.setState({
      page: 1
    });

  };


  onLastClick = () => {

    const totalPages =
      Math.ceil(this.state.totalCount / this.state.pageSize);

    this.setState({
      page: totalPages
    });

  };


  onRecordsPerPageCountChange = (size) => {

    this.setState({
      pageSize: Number(size),
      page: 1
    });

  };


  // =====================
  // HEADER BUTTON
  // =====================

  onHeaderButtonClicked = (btn) => {

    if (btn.Action === "new") {

      this.setState({
        showAddMessageTemplate: true,
        selectedRow: null
      });

    }

  };


  // =====================
  // ROW BUTTON
  // =====================

  onRowButtonClicked = (btn, row) => {

    if (btn.Type === "edit") {

      this.setState({
        showAddMessageTemplate: true,
        selectedRow: row
      });

    }

    if (btn.Type === "delete") {

      this.setState({
        showDelete: true,
        selectedRow: row
      });

    }

  };


  // =====================
  // DELETE
  // =====================

  deleteRecord = async () => {

    try {

      this.setState({
        loading: true,
        showDelete: false
      });

      await this.props.deleteSMSTemplate(
        this.state.selectedRow.key
      );

      this.props.getToastr(
        "sms template deleted successfully"
      );

      this.setState({
        selectedRow: null,
        loading: false
      });

      this.loadData();

    } catch (error) {

      console.error(error);

      this.setState({
        loading: false,
        selectedRow: null
      });

      this.props.getToastr(
        "Failed to delete sms template"
      );

    }

  };


  // =====================
  // POPUP
  // =====================

  onClosePopup = () => {

    this.setState({
      showAddMessageTemplate: false,
      selectedRow: null
    });

  };


  onPostPopupSave = () => {

    this.setState({
      showAddMessageTemplate: false,
      selectedRow: null
    });

    this.loadData();

  };


  // =====================
  // PAGINATED DATA
  // =====================

  getPagedList = () => {

    const start =
      (this.state.page - 1) * this.state.pageSize;

    const end =
      start + this.state.pageSize;

    return this.state.list.slice(start, end);

  };


  // =====================
  // RENDER
  // =====================
  onPageChange = (page, pageSize) => {
  console.log("page",page);
  this.setState(
    { page, pageSize },
    () => {
      this.loadData();
    }
  );
};

  render() {

    return (

      <>

        <ListingPage
onPageChange={this.onPageChange}
          {...this.props}

          listPageSettings={{
            ...this.state.listPageSettings
          }}

          list={this.getPagedList()}

          loading={this.state.loading}

          totalItemsCount={this.state.totalCount}

          recordFrom={
            (this.state.page - 1)
            * this.state.pageSize
          }

          itemsCountPerPage={
            this.state.pageSize
          }

          onNextClick={this.onNextClick}

          onPreviousClick={
            this.onPreviousClick
          }

          onFirstClick={this.onFirstClick}

          onLastClick={this.onLastClick}

          onRecordsPerPageCountChange={
            this.onRecordsPerPageCountChange
          }

          onHeaderButtonClicked={
            this.onHeaderButtonClicked
          }

          onRowButtonClicked={
            this.onRowButtonClicked
          }

        />


        {/* DELETE */}

        {this.state.showDelete && (

          <Window

            header="Delete"

            modal

            onClose={() =>
              this.setState({
                showDelete: false
              })
            }

            onButtonClick={(btn) => {

              if (btn === "Yes")
                this.deleteRecord();

              else
                this.setState({
                  showDelete: false
                });

            }}

            buttons={[
              {
                Type: "secondary",
                Text: "No",
                Align: "left"
              },
              {
                Type: "primary",
                Text: "Yes",
                Align: "right"
              }
            ]}

          >

            Are you sure you want to delete?

          </Window>

        )}


        {/* ADD / EDIT */}

        {this.state.showAddMessageTemplate && (

          <SMS
            {...this.props}
            sms={this.state.selectedRow}
            smsType="Transactional"
            onSave={() => this.onPostPopupSave()}
            onClose={() => this.onClosePopup()}
          />

        )}

      </>

    );

  }

}

export default TransactionSMSTemplateList;